/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import DigitalImage from "../../../../assets/final-images/servicepage/personal-injury-page/Artboard 1.jpg";
import CTmaskImage from "../../../../assets/final-images/servicepage/personal-injury-page/Artboard 2.jpg";
import DWI from "../../../../assets/final-images/servicepage/personal-injury-page/Artboard 3.jpg";
import MRIShoulder from "../../../../assets/final-images/servicepage/personal-injury-page/Artboard 4.jpg";
import NeclearBoneScan from "../../../../assets/final-images/servicepage/personal-injury-page/Artboard 5.jpg";
import ultrasound from "../../../../assets/final-images/servicepage/personal-injury-page/Artboard 6.jpg";
import dti from "../../../../assets/final-images/servicepage/personal-injury-page/Artboard 7.jpg";
import spine_mri from "../../../../assets/final-images/servicepage/personal-injury-page/Artboard 8.jpg";
import InjuredPersonImage from "../../../../assets/final-images/servicepage/personal-injury-page/personal_big.jpg";
import scanningImage from "../../../../assets/final-images/servicepage/personal-injury-page/scan-2.png";
import shape from "../../../../assets/final-images/shapes/7-01-01.png";
import { Link } from "react-router-dom";
import { useLenis } from "../../../SmoothScroll";
import DoneIcon from "@mui/icons-material/Done";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Faqs from "../../../Faqs";
import { Helmet } from "react-helmet-async";
export default function PersonalInjuryImaging() {
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page0
  }, []);
  const faqs = [
    {
      question:
        "Does Citrus Diagnostic Center perform MRI for patients injured in auto accidents in Citrus County and the Nature Coast region?",
      answer:
        "Yes. Citrus Diagnostic Center is a physician-owned, radiologist-operated outpatient imaging center in Crystal River, FL providing prompt, high-quality MRI and diagnostic imaging for patients injured in motor vehicle accidents, motorcycle accidents, truck accidents, pedestrian accidents, and bicycle accidents throughout Citrus County, Hernando County, Levy County, and the surrounding Nature Coast region. We offer same-day and next-day scheduling in most cases. Every MRI is interpreted and signed by our board-certified radiologist - not an out-of-state teleradiology service - ensuring detailed, accurate, and defensible reports.",
    },
    {
      question:
        "What MRI studies are typically ordered after a motor vehicle accident?",
      answer:
        "Following a motor vehicle accident, the most commonly ordered MRI studies include: cervical spine MRI (the most frequently injured region in rear-end and frontal collisions), lumbar spine MRI (lower back disc disease and nerve impingement), thoracic spine MRI, brain MRI (for head impact, loss of consciousness, or traumatic brain injury symptoms), shoulder MRI (rotator cuff and labral injuries), knee MRI (meniscus and ligament injuries), and wrist or ankle MRI for extremity injuries. Citrus Diagnostic Center performs all of these studies with results read by our on-site radiologist.",
    },
    {
      question:
        "Why is MRI better than X-ray for diagnosing injuries after a car accident?",
      answer:
        "X-ray detects fractures but is essentially blind to soft tissue injuries - which account for the majority of pain and disability following motor vehicle accidents. MRI directly visualizes intervertebral discs, nerve roots, spinal cord, ligaments, tendons, and muscles. Conditions such as cervical disc herniation, lumbar disc bulge with nerve compression, ligamentous instability, rotator cuff tears, and mild traumatic brain injury are only reliably diagnosed with MRI. For patients pursuing medical treatment or legal claims, MRI is the medically and legally appropriate standard of care for soft tissue injury documentation.",
    },
    {
      question: "How soon after a car accident should I get an MRI?",
      answer:
        "Earlier imaging is better - both medically and legally. From a medical standpoint, prompt MRI helps your treating physician identify injuries quickly and initiate treatment before conditions worsen. From a legal and insurance standpoint, delays in obtaining imaging can be used by insurance adjusters to argue injuries are not accident-related. Critically, Florida's PIP law has a 14-day rule requiring you to seek medical treatment within 14 days of the accident to preserve your PIP benefits. Citrus Diagnostic Center offers prompt scheduling to ensure your injuries are documented in a timely manner.",
    },
    {
      question:
        "What is Florida's PIP 14-day rule and how does it affect my ability to get imaging?",
      answer:
        "Florida's Personal Injury Protection (PIP) law - under Florida Statute 627.736 - requires that an injured person seek initial medical treatment from a licensed healthcare provider within 14 days of the accident to be eligible for PIP benefits. If you do not seek medical care within this window, you forfeit your right to PIP coverage entirely. Once a physician has ordered imaging, Citrus Diagnostic Center can schedule your study promptly. PIP covers up to $10,000 in medical benefits for emergency medical conditions and up to $2,500 for non-emergency conditions. Do not wait.",
    },
  ];
  return (
    <>
    <Helmet>

      
       <title>Personal Injury Imaging in Florida | Citrus County

</title>
        <meta
          name="description"
          content="Personal injury MRI in Crystal River, Florida with PIP imaging for auto accidents, soft tissue and traumatic brain injuries, ensuring accurate evaluation and reporting.
"
        />
        <meta
          name="keywords"
          content="Medical Imaging for personal injury
soft tissue injury
traumatic brain injuries
personal injury imaging
PIP Imaging


"
        />
    </Helmet>
      <div>
        <div className=" font-robout">
          <div className="flex flex-col justify-center items-center px-5 xl:px-0 xl:py-36 text-center">
            <h1
              data-aos="fade-right"
              className="font-heading lg:text-[72px] text-[28px] leading-[1.4em] text-[#f5f5f5] font-normal capitalize"
            >
              Personal Injury / Workers' Compensation
            </h1>
            <p className="pb-3">
              Auto Accident Injury Imaging / Personal Injury Protection (PIP)
              Imaging / Slip and Fall Injury Imaging / Attorney LOP Imaging
            </p>
            <p
              data-aos="fade-right"
              data-aos-delay="100"
              className=" text-[#cccccc] font-normal "
            >
              Clarity after trauma. Precision you can rely on.
            </p>
            <div className=" pt-5 mt-3 pb-5">
              <Link
                data-aos="fade-up"
                to="/contact-us"
                aria-label="Schedule Now"
                className="px-8 py-2.5 rounded-3xl bg-white text-black font-bold text-[17px] hover:bg-black hover:border hover:text-white border border-[#ffffff5d] transition-all duration-300"
              >
                Schedule Now
              </Link>
            </div>
          </div>
        </div>
        <div className="relative md:max-w-[90%] w-11/12 mx-auto py-20 overflow-hidden xl:bg-[#0f0f0f] rounded-xl xl:my-10">
          {/* 🔥 Background Shape */}
          <img
            src={shape}
            alt="Citrus Diagnostic Center"
            className="
      absolute 
      top-1/2 
      left-1/2 
      -translate-x-1/2 
      -translate-y-1/2 
      pointer-events-none 
      z-0
      opacity-75
    "
          />

          <div
            className=" backdrop-blur-[2px]
    bg-[#ffffff13] rounded-xl
      shadow-lg w-full xl:w-[80%] mx-auto py-8 xl:py-16"
          >
            {/* ✅ Content */}
            <div className="relative z-10 text-center flex items-center flex-col ">
              <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading capitalize pt-8 xl:pt-0 pb-8">
                Imaging That Matters-When It Matters Most
              </h2>

              <p className="pb-2">
                After a motor vehicle accident or personal injury, time,
                accuracy, and documentation are critical.
              </p>

              <p className="lg:w-2/3 text-center pb-2">
                Citrus Diagnostic Center is{" "}
                <span className="font-extrabold">
                  a regional leader in personal injury imaging
                </span>
                , offering comprehensive, multi-modality studies designed to
                detect both obvious and subtle injuries-interpreted by
                <span className="font-extrabold">
                  {" "}
                  board-certified, fellowship-trained radiologists
                </span>{" "}
                with trauma and academic experience.
              </p>
            </div>

            {/* SECOND BLOCK */}
            <div className="relative z-10 py-10 md:max-w-[90%] w-11/12 mx-auto flex justify-center ">
              <div className="flex justify-center">
                <div className="w-full  px-4 text-left grid grid-cols-1 xl:grid-cols-2 xl:gap-10">
                  <div className="pb-8 flex flex-col justify-center items-start">
                    <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading capitalize">
                      Why Personal Injury Imaging Is Different
                    </h2>

                    <p className="text-[#cccccc] font-normal">
                      Not all imaging is equal in injury cases.
                    </p>
                  </div>

                  <div className="flex ">
                    <div className="inline-block text-left">
                      <p className="pb-2 ">At Citrus Diagnostic Center:</p>

                      <div className="flex ">
                        <ul className="w-fit text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 text-left">
                          <li className="flex items-start gap-2">
                            <DoneIcon className="text-[#bf9c5a] mt-[2px] shrink-0" />
                            <span>
                              Imaging protocols are{" "}
                              <span className="font-extrabold">
                                radiologist-designed
                              </span>
                              , not generic
                            </span>
                          </li>

                          <li className="flex items-start gap-2">
                            <DoneIcon className="text-[#bf9c5a] mt-[2px] shrink-0" />
                            <span>
                              Studies are tailored to{" "}
                              <span className="font-extrabold">
                                mechanism of injury
                              </span>
                            </span>
                          </li>

                          <li className="flex items-start gap-2">
                            <DoneIcon className="text-[#bf9c5a] mt-[2px] shrink-0" />
                            <span>
                              Subtle findings are actively evaluated-not
                              dismissed
                            </span>
                          </li>

                          <li className="flex items-start gap-2">
                            <DoneIcon className="text-[#bf9c5a] mt-[2px] shrink-0" />
                            <span>
                              Reports are{" "}
                              <span className="font-extrabold">
                                clear, consistent, and defensible
                              </span>
                            </span>
                          </li>
                        </ul>
                      </div>

                      <p className="py-2 ">
                        This approach supports{" "}
                        <span className="font-extrabold">
                          patients, referring clinicians, and legal
                          professionals
                        </span>{" "}
                        alike.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            background:
              "linear-gradient(to right, #3d0e26 0%, #8b5e3c 50%,  #330a16 100%)",
          }}
        >
          <div className="md:max-w-[90%] w-11/12 mx-auto py-20">
            <h2 className="font-heading lg:text-[52px] text-[28px] leading-[1.4em] text-[#f5f5f5] font-normal  capitalize text-center py-10 ">
              Comprehensive Injury Imaging (All Modalities)
            </h2>
            <div className="bg-[#0f0f0f] rounded-xl p-5 xl:p-10  my-10 ">
              <div className="grid grid-col-1 xl:grid-cols-2 gap-8 my-16 m ">
                <div className=" flex flex-col justify-center items-start xl:pl-20 px-5 xl:px-0 ">
                  <div className="pb-8">
                    <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  text-left capitalize ">
                      Digital X-Ray
                    </h2>
                    <p className=" text-[#cccccc] font-normal">
                      The foundation of trauma imaging
                    </p>
                  </div>
                  <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 ">
                    <li className="flex items-start gap-1">
                      <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>Fractures and dislocations</span>
                    </li>

                    <li className="flex items-start gap-1">
                      <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>Alignment and instability</span>
                    </li>

                    <li className="flex items-start gap-1">
                      <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>Initial injury documentation</span>
                    </li>
                  </ul>
                </div>
                <div>
                  <img
                    src={DigitalImage}
                    alt="Digital X-Ray"
                    className="w-auto h-auto  rounded-3xl"
                  />
                </div>
                <div className="order-2 xl:order-1">
                  <img
                    src={CTmaskImage}
                    alt="CT Imaging"
                    className="w-auto h-auto rounded-3xl"
                  />
                </div>
                <div className="flex flex-col justify-center items-start px-5 xl:px-0 order-1 xl:order-2 xl:ps-10 ps-0">
                  <div className="pb-8">
                    <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  text-left capitalize ">
                      CT Imaging
                    </h2>
                    <p className=" text-[#cccccc] font-normal">
                      Speed and detail for acute injury
                    </p>
                  </div>
                  <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                    <li className="flex items-start gap-2">
                      <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>Head and spine trauma</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>Complex fractures</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>Thoracic and abdominal injury</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>High-resolution multiplanar reconstructions</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="grid grid-col-1 xl:grid-cols-2 gap-8  mb-16 ">
                <div className="flex flex-col justify-center items-start px-5 xl:px-0">
                  <div className="pb-8">
                    <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  text-left capitalize ">
                      MRI
                    </h2>
                    <p className=" text-[#cccccc] font-normal">
                      The gold standard for soft tissue and neurologic injury
                    </p>
                  </div>
                  <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                    <li className="flex items-start gap-1">
                      <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span className="font-extrabold">Brain MRI</span>
                    </li>

                    <li className="flex items-start gap-1">
                      <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>
                        <span className="font-extrabold">
                          Brain DTI (Diffusion Tensor Imaging)
                        </span>{" "}
                        for TBI
                      </span>
                    </li>

                    <li className="flex items-start gap-1">
                      <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>Cervical, thoracic, and lumbar spine MRI</span>
                    </li>

                    <li className="flex items-start gap-1">
                      <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span className="font-extrabold">
                        Dedicated whiplash protocols
                      </span>
                    </li>

                    <li className="flex items-start gap-1">
                      <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>
                        Focused evaluation of the{" "}
                        <span className="font-extrabold">alar ligaments</span>
                      </span>
                    </li>

                    <li className="flex items-start gap-1">
                      <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>Muscles, ligaments, discs, and spinal cord</span>
                    </li>
                  </ul>
                  <p className="py-2  text-[#cccccc] font-normal">
                    MRI is often essential when symptoms persist despite normal
                    X-ray or CT findings.
                  </p>
                </div>
                <div>
                  <img
                    src={DWI}
                    alt="Brain DTI (Diffusion Tensor Imaging)"
                    className="w-auto h-auto  rounded-3xl"
                  />
                </div>
                <div className="order-2 xl:order-1">
                  <img
                    src={MRIShoulder}
                    alt="Designed for Diagnostic Reliability in Trauma Imaging"
                    className="w-auto h-auto  rounded-3xl"
                  />
                </div>
                <div className="xl:p-8 p-5 flex justify-center items-start flex-col order-1 xl:order-2">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  text-left capitalize pb-8">
                    Designed for Diagnostic Reliability in Trauma Imaging
                  </h2>
                  <p className="pb-2">
                    In personal injury and trauma cases, imaging findings may be
                    subtle and clinically significant. Image clarity and
                    consistency are critical.
                  </p>
                  <p className="pb-2 ">
                    MRI exams at Citrus Diagnostic Center are performed in{' '}
                    <span className="font-extrabold">
                      dedicated, in-building imaging suites
                    </span>{" "}
                    designed to support:
                  </p>
                  <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                    <li className="flex items-start gap-2">
                      <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>Stable magnetic performance</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>Reduced image artifacts</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>
                        Reliable evaluation of soft tissues, ligaments, and the
                        spine
                      </span>
                    </li>
                  </ul>

                  <p className=" py-2 ">
                    This approach helps ensure injuries are assessed{" "}
                    <span className="font-extrabold">
                      accurately the first time
                    </span>
                    , supporting both clinical care and long-term confidence.
                  </p>
                </div>
              </div>
            </div>
           
            <div className="bg-[#0f0f0f] rounded-xl p-5 xl:p-10  my-10 ">
              <div className="grid grid-col-1 xl:grid-cols-2 gap-8 mt-10 mb-14">
                <div className="xl:p-8 p-5 flex justify-center items-start flex-col">
                  <div className="pb-8">
                    <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  text-left capitalize ">
                      Nuclear Medicine
                    </h2>
                    <p className=" text-[#cccccc] font-normal">
                      When physiology matters
                    </p>
                  </div>
                  <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                    <li className="flex items-start gap-2">
                      <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>
                        <span className="font-extrabold">Bone Scan</span> for
                        occult fractures, stress injuries, and delayed findings
                      </span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>
                        Useful when MRI or CT findings are inconclusive
                      </span>
                    </li>
                  </ul>
                </div>
                <div>
                  <img
                    src={NeclearBoneScan}
                    alt="Nuclear Medicine"
                    className="w-auto h-auto  rounded-3xl"
                  />
                </div>
                <div className="order-2 xl:order-1">
                  <img
                    src={ultrasound}
                    alt=" Ultrasound"
                    className="w-auto h-auto  rounded-3xl"
                  />
                </div>
                <div className="flex flex-col justify-center items-start px-5 xl:px-0 order-1 xl:order-2 xl:ps-10 ps-0">
                  <div className="pb-8">
                    <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  text-left capitalize ">
                      Ultrasound
                    </h2>
                    <p className=" text-[#cccccc] font-normal">
                      Dynamic, radiation-free evaluation
                    </p>
                  </div>
                  <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 ">
                    <li className="flex items-start gap-1">
                      <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>Soft tissue injury</span>
                    </li>

                    <li className="flex items-start gap-1">
                      <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>Tendons and ligaments</span>
                    </li>

                    <li className="flex items-start gap-1">
                      <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>Vascular assessment</span>
                    </li>

                    <li className="flex items-start gap-1">
                      <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>Targeted follow-up imaging</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="bg-[#0f0f0f] rounded-xl p-5 xl:p-10 my-10 ">
              <div className="grid grid-col-1 xl:grid-cols-2 gap-8 mt-10 mb-20">
                <div className="flex flex-col justify-center">
                  <div className="pb-8">
                    <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  text-left capitalize ">
                      Traumatic Brain Injury (TBI) & Concussion Imaging
                    </h2>
                    <p className=" text-[#cccccc] font-normal">
                      When Symptoms Don’t Match Basic Imaging
                    </p>
                  </div>
                  <p className=" pb-2 ">
                    Concussion and mild TBI may not be visible on routine
                    imaging.
                  </p>
                  <p className=" pb-2 ">
                    <span className="font-extrabold">Brain DTI MRI</span>{" "}
                    evaluates white matter integrity and is particularly
                    valuable for:
                  </p>
                  <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 ">
                    <li className="flex items-start gap-2">
                      <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>Post-concussive symptoms</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>Cognitive changes</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>Head injury following motor vehicle accidents</span>
                    </li>
                  </ul>
                  <p className=" py-2 ">
                    Performed and interpreted by radiologists with{" "}
                    <span className="font-extrabold">
                      academic neuroimaging and trauma-center experience
                    </span>
                    .
                  </p>
                </div>
                <div>
                  <img
                    src={dti}
                    alt="DTI imaging"
                    className="w-auto h-auto rounded-3xl"
                  />
                </div>
              </div>
              <div className="grid grid-col-1 xl:grid-cols-2 gap-8 my-10 ">
                <div className="order-2 xl:order-1">
                  <img
                    src={spine_mri}
                    alt=" Spine & Whiplash Imaging"
                    className="w-auto h-auto rounded-3xl"
                  />
                </div>
                <div className="flex flex-col justify-center xl:ps-10 order-1 xl:order-2 ">
                  <div className="pb-8">
                    <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  text-left capitalize ">
                      Spine & Whiplash Imaging
                    </h2>
                    <p className=" text-[#cccccc] font-normal">
                      Precision for Cervical Trauma
                    </p>
                  </div>
                  <p className="pb-2">Whiplash injuries often involve:</p>
                  <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                    <li className="flex items-start gap-2">
                      <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>Ligamentous injury</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>Subtle instability</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>Soft tissue damage</span>
                    </li>
                  </ul>
                  <p className="py-2">
                    Our cervical spine MRI protocols include:
                  </p>
                  <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                    <li className="flex items-start gap-2">
                      <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>High-resolution soft tissue imaging</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span className="font-extrabold">
                        Dedicated alar ligament evaluation
                      </span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                      <span>
                        Comprehensive spine assessment correlated to symptoms
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="md:max-w-[90%] w-11/12 mx-auto py-20">
          <div>
            <div className="lg:py-10 py-5">
              <div className="pb-8">
                <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  text-left capitalize ">
                  Florida PIP & Personal Injury Imaging Considerations
                </h2>
                <p className=" text-[#cccccc] font-normal">
                  The 14-Day Rule (Florida PIP)
                </p>
              </div>
              <p className=" pb-2 xl:w-3/5">
                Under Florida law, individuals injured in a motor vehicle
                accident must generally{" "}
                <span className="font-extrabold">
                  seek medical evaluation and treatment within 14 days
                </span>{" "}
                to remain eligible for Personal Injury Protection (PIP) medical
                benefits.
              </p>
              <p className="pb-2 ">Early imaging can be critical for:</p>
              <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 ">
                <li className="flex items-start gap-1">
                  <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                  <span>Establishing injury documentation</span>
                </li>

                <li className="flex items-start gap-1">
                  <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                  <span>Supporting medical necessity</span>
                </li>

                <li className="flex items-start gap-1">
                  <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                  <span>Guiding appropriate care</span>
                </li>
              </ul>
              <p className="py-2 ">
                (<span className="text-[#bf9c5a]">Note:</span> This information
                is provided for general educational purposes and is not legal
                advice.)
              </p>
            </div>
            <div className="grid grid-col-1 xl:grid-cols-2 lg:gap-20 gap-10 mt-10">
              <div>
                <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  text-left capitalize mb-8">
                  Imaging as Medical Documentation
                </h2>
                <p className="pb-2 ">
                  High-quality imaging plays a key role in:
                </p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 ">
                  <li className="flex items-start gap-2">
                    <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>Injury assessment</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>Treatment planning</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>
                      Objective documentation of trauma-related findings
                    </span>
                  </li>
                </ul>
                <p className=" py-2 ">
                  At Citrus Diagnostic Center, reports are:
                </p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 ">
                  <li className="flex items-start gap-2">
                    <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>Thorough and In-depth</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>Clinically grounded</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>Consistent and reproducible</span>
                  </li>
                </ul>
              </div>
              <div>
                <div className="pb-8">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  text-left capitalize ">
                    Concierge Service for Attorneys & Referring Providers
                  </h2>
                  <p className="text-[#cccccc] font-normal">
                    Built for Efficiency. Designed for Collaboration.
                  </p>
                </div>
                <p className=" pb-2 ">
                  We provide{" "}
                  <span className="font-extrabold">
                    concierge-level support
                  </span>{" "}
                  for:
                </p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                  <li className="flex items-start gap-1">
                    <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>Personal injury attorneys</span>
                  </li>

                  <li className="flex items-start gap-1">
                    <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>Referring chiropractors</span>
                  </li>

                  <li className="flex items-start gap-1">
                    <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>Treating physicians</span>
                  </li>

                  <li className="flex items-start gap-1">
                    <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>Their patients</span>
                  </li>
                </ul>
                <p className="py-2 ">This includes:</p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                  <li className="flex items-start gap-2">
                    <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>Streamlined scheduling</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>Protocol coordination</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>Rapid record fulfillment</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="text-[#bf9c5a]  mt-[2px]" />
                    <span>Clear communication</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="w-full flex justify-center items-center pt-20">
              <img
                src={InjuredPersonImage}
                alt="Personal Injury at CDC"
                className="w-auto h-auto  rounded-xl"
              />
            </div>
            <div className="relative">
              <img
                src={scanningImage}
                alt="Shoulder Scanning"
                className="
    absolute 
    top-1/2 
    left-1/2 
    -translate-x-1/2 
    -translate-y-1/2 
    pointer-events-none 
    z-0
    opacity-15
  "
              />
              <div
                className=" backdrop-blur-[2px]
    xl:bg-[#ffffff13] rounded-xl
      shadow-lg  py-8 xl:py-32 xl:px-16 xl:my-20"
              >
                <div className="grid grid-col-1 xl:grid-cols-2 lg:gap-20 gap-10 mt-10">
                  <div className="lg:py-10 py-5">
                    <div className="pb-8">
                      <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  text-left capitalize ">
                        Digital Records & Legal Requests
                      </h2>
                      <p className=" text-[#cccccc] font-normal">
                        No discs. No delays. No friction.
                      </p>
                    </div>
                    <p className="pb-2">
                      Citrus Diagnostic Center leverages{" "}
                      <span className="font-extrabold">Clearpath</span> to
                      deliver imaging and records through a{" "}
                      <span className="font-extrabold">
                        secure, digital release-of-information platform
                      </span>
                      .
                    </p>
                    <p className="text-[#cccccc] font-normal pb-2">
                      Why This Matters:
                    </p>
                    <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                        <span>Faster access to records</span>
                      </li>

                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                        <span>Secure, compliant delivery</span>
                      </li>

                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                        <span>No physical discs to manage</span>
                      </li>

                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                        <span>Reduced administrative burden</span>
                      </li>
                    </ul>
                    <p className="  py-2 mb-3 ">
                      This reflects the{" "}
                      <span className="font-extrabold">new standard</span> in
                      medical-legal imaging workflows.
                    </p>
                    <div className="mt-10">
                      <Link
                        to="https://prod.myclearpath.com/login"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="px-8 py-2.5 rounded-3xl  bg-white text-black font-bold text-[17px] hover:bg-black hover:border hover:text-white border border-[#ffffff5d] transition-all duration-300"
                      >
                        Legal Login
                      </Link>
                    </div>
                  </div>
                  <div className="lg:py-10 py-5">
                    <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  text-left capitalize pb-8">
                      Why Choose Citrus Diagnostic Center for Personal Injury
                      Imaging
                    </h2>
                    <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                        <span>Radiologist owned and operated</span>
                      </li>

                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                        <span>
                          Fellowship-trained, board-certified radiologists
                        </span>
                      </li>

                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                        <span>
                          Academic-level MRI, CT, and nuclear medicine
                        </span>
                      </li>

                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                        <span>Advanced DTI and whiplash protocols</span>
                      </li>

                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                        <span>Multi-modality imaging under one roof</span>
                      </li>

                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="text-[#bf9c5a]  mt-[2px]" />
                        <span>
                          Digital legal record delivery with Clearpath
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="lg:w-[80%] w-[90%] mx-auto pb-10 ">
              <Faqs faqs={faqs} />
            </div>
            <div className="flex justify-center items-center py-10">
              <div
                style={{
                  background: `
    linear-gradient(90deg,
  #3d0e26 0%,
  #5a1f33 1%,
  #8b5e3c 40%,
  #8b5e3c 70%,
  #5a1f33 95%,
  #330a16 100%
)
  `,
                }}
                className="flex justify-center items-center flex-col py-8 px-6 xl:px-8 rounded-xl xl:w-[668px] "
              >
                <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading texc  capitalize  ">
                  Take the Next Step
                </h2>
                <p className=" pt-5  text-center">
                  If you’ve been injured-or care for patients who have-
                  <span className="font-extrabold">
                    experience imaging designed for accuracy, clarity, and
                    confidence
                  </span>
                  .
                </p>
                <div className="pt-10 pb-2">
                  <Link
                    data-aos="fade-up"
                    to="/contact-us"
                    aria-label="Schedule Now"
                    className="px-8 py-2.5 rounded-3xl bg-white text-black font-bold text-[17px] hover:bg-black hover:border hover:text-white border border-[#ffffff5d] transition-all duration-300"
                  >
                    Schedule Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
